import {ChatState} from './states/chat.state';

export const chatStates = [
    ChatState
];
